let shopId: number | undefined;

export function getShopId(): number {
  if (shopId !== undefined) {
    return shopId;
  }
  const dataChannel = document.body.dataset.channel;
  shopId = dataChannel !== undefined ? parseInt(dataChannel, 10) : 100001;

  return shopId;
}
